<template>
  <div class="about contact-page text-white">
    <div class="container pt-5">
      <h2>Sobre a CIES</h2>
      <p class="">
        A Copa IFCE de e-Sports – CIES é um evento esportivo de jogos digitais que ocorre periodicamente no IFCE - Campus
        Aracati e em breve, Maracanaú. Um dos seus objetivos é proporcionar integração entre a acadêmia e comunidade promovendo 
        interação social, desportividade e incentivando a boa conduta com outros jogadores.
        <br/>
        O projeto CIES não possui fins lucrativos e é incentivado e apoiado pelo IFCE Campus Aracati e coordenado por Docentes, Discentes e voluntários que
        se propõem a contribuir com o crescimento do evento e difusão do mesmo.
        <br/>
        A inscrição de jogadores para participação nos campeonatos se dará através da doação de 1KG de alimento não perecível. Todos os alimentos arrecadados
        durante a inscrição e fase de competição serão posteriormente doados a instituíções de apoio à comunidade (caridade, dependentes químicos, projetos, etc.).
      </p>
      <h2>Sobre este site</h2>
      <p class="">
        O site ainda está em fase de desenvolvimento e está sendo atualizado constantemente. Os períodos de inscrição, datas dos campeonatos, jogos e demais
         informações serão dispostas aqui, neste site. Este projeto não possui fins lucrativos e é desenvolvido por voluntários que dedicam seu tempo livre para
         a construção deste web site.
         <br/>
         Encontrou algum erro ou tem alguma sugestão? Relate clicando 
         <a href="https://forms.gle/kjnH3ffGUcMf7qeX6">aqui</a>.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.about {
  padding-top: 100px;
}
a {
  color: #B01BA5 !important;
}
p {
  padding: 3vh 5vh 0vh 5vh;
}
</style>
